var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5h15.75v10.5H2V5z",
    stroke: "#000064",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000064",
    strokeWidth: 1.5,
    d: "M2 9.25h15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000064",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    d: "M7.75 2.75v4.5M11.75 2.75v4.5"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0yIDVIMTcuNzVWMTUuNUgyVjVaIiBzdHJva2U9IiMwMDAwNjQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPg0KPGxpbmUgeDE9IjIiIHkxPSI5LjI1IiB4Mj0iMTciIHkyPSI5LjI1IiBzdHJva2U9IiMwMDAwNjQiIHN0cm9rZS13aWR0aD0iMS41Ii8+DQo8bGluZSB4MT0iNy43NSIgeTE9IjIuNzUiIHgyPSI3Ljc1IiB5Mj0iNy4yNSIgc3Ryb2tlPSIjMDAwMDY0IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+DQo8bGluZSB4MT0iMTEuNzUiIHkxPSIyLjc1IiB4Mj0iMTEuNzUiIHkyPSI3LjI1IiBzdHJva2U9IiMwMDAwNjQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4NCjwvc3ZnPg0K";
export { SvgDateIcon as ReactComponent };